module.exports = __webpack_public_path__ + "3146e7c1d92811c6a223eb53dea2112b.svg";